import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSearchLayoutCarrierFuelSurchargePay extends Layout {
    panel1: Panel;
    panel4: Panel;
    panel5: Panel;
    panelFormula: Panel;
    sourceCustomerFuelOptions: DataSource;
    textboxAmount: Textbox;
    textboxApplyDoeRate: Textbox;
    textboxBasePrice: Textbox;
    textboxCustomCalc: Textbox;
    textboxCustomFscHdrId: Textbox;
    textboxCustomFscIndexId: Textbox;
    textboxCustomFscRegionId: Textbox;
    textboxDateOpt: Textbox;
    textboxDeductCodeId: Textbox;
    textboxDelayDays: Textbox;
    textboxDescr: Textbox;
    textboxFscCycleCode: Textbox;
    textboxFuelPercent: Textbox;
    textboxFuelSurchargePayId: Textbox;
    textboxFuelVariance: Textbox;
    textboxMethod: Textbox;
    textboxRegion: Textbox;
    textboxRoundSurchgCalc: Textbox;
    textboxSurchgEnddt: Textbox;
    textboxSurchgStrtdt: Textbox;
}
